import { MailOutlined } from '@ant-design/icons';
import { ItemType } from 'antd/lib/menu/interface';

type TInviteAllListItemProps = {
    onOpenModal: () => void;
};

export const getInviteAllListItem = ({ onOpenModal }: TInviteAllListItemProps): ItemType => ({
    key: 'invite-all',
    label: 'Invitation Email',
    icon: <MailOutlined />,
    onClick: () => {
        onOpenModal();
    },
});
